import {ChangeDetectionStrategy, Component, ViewEncapsulation} from '@angular/core';
import {RoutesEnums} from '../../../enums/RoutesEnums';
import {AppConfigService} from '../../../services/app-config.service';

@Component({
  selector: 'app-sidebar-ad-placeholder',
  templateUrl: './sidebar-ad-placeholder.component.html',
  styleUrls: ['./sidebar-ad-placeholder.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarAdPlaceholderComponent {
  public imgSrc: string;
  public url: string[];

  constructor(private appConfigService: AppConfigService) {
    this.imgSrc = `${appConfigService.appConfig.amazonS3Url}assets/ads/default-320x600-right-banner-1a.webp`;
    this.url = ['/', RoutesEnums.PAGE, 'om-varden', 'om-oss'];
  }
}
